import { type CustomerOrderListItemDto } from './customer-order-list-item-dto';
import { ArchivedCustomerOrder, Customer, CustomerSetting } from '../../entities';
import { type OrderStatus } from '../../types';
import { LocalDate } from '../../utils/local-date';

/**
 * A row of the archived customer orders list, as returned by the archived customer order controller
 */
export interface ArchivedCustomerOrderListItemDto {
  id: number;
  orderDate: string;
  status: OrderStatus;
  siteNames: string | null;
  siteNamesWithDisplayNumber: string | null;
  createdBy: string | null;
  customer: CustomerOrderListItemDto['customer'];
}

/**
 * Maps an archived customer orders list row to an ArchivedCustomerOrder shaped like the ones loaded through the
 * JSON:API, so that it can be passed to the components which still use the JSON:API (order view, clone modal)
 */
// TODO: Update this funtion to use one ArchivedCustomerOrder structure after migrating from JSON:API
export const toArchivedCustomerOrder = (
  item: ArchivedCustomerOrderListItemDto
): ArchivedCustomerOrder =>
  Object.assign(new ArchivedCustomerOrder(), {
    id: String(item.id),
    orderDate: new LocalDate(item.orderDate),
    status: item.status,
    siteNames: item.siteNames ?? undefined,
    siteNamesWithDisplayNumber: item.siteNamesWithDisplayNumber ?? undefined,
    originalCreatedBy: item.createdBy ?? undefined,
    customer: Object.assign(new Customer(), {
      id: item.customer ? String(item.customer.id) : undefined,
      name: item.customer?.name,
      customerSetting: Object.assign(new CustomerSetting(), item.customer?.customerSetting ?? {}),
    }),
  });
